module.exports = __webpack_public_path__ + "media/images/apple_logo-97a4f7c21e629d85852e3fbb2f25dd1b.png";